import React from "react";

const OverviewSection = () => {
  return (
    <section className='overflow-hidden bg-[#F1F1F1]'>
      <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] md:px-[40px] px-[20px] lg:py-[88px] py-[40px] relative">
        <div className="flex flex-col lg:flex-row relative w-full items-center justify-between">
          <div className="w-full lg:max-w-[671px] z-0 flex justify-center lg:justify-start">
            <img
              src="/assets/v/item8.jpg"
              alt="who-we-are"
              className="w-full h-auto max-h-[300px] sm:max-h-[400px] lg:max-h-none object-cover rounded-sm"
            />
          </div>
          <div className="
                relative           
                lg:absolute        
                lg:right-0 
                lg:top-[50%] lg:-translate-y-[50%] 
                -mt-[40px] sm:-mt-[60px] lg:mt-0 
                z-10 
                max-w-[90%] sm:max-w-[85%] lg:max-w-[789px] 
                w-full
                lg:p-[40px] p-[20px] sm:p-[30px] 
                bg-[#FFFFFF] border border-[#01386A45] rounded-sm shadow-sm
            ">
            <h6 className="font-[600] font-sora lg:text-[30px] text-[20px] lg:leading-[40px] leading-[30px] lg:pb-[40px] pb-[16px] text-[#01386A]">
              Overview
            </h6>
            <p className="font-[500] font-graphik text-[14px] md:text-[16px] leading-[1.5] text-[#49577A]">
              Makers Lab is a space where ideas come alive. It brings together creators, thinkers, and innovators to experiment, build, and learn by doing. With the right tools, support, and collaborative environment, it helps turn simple ideas into real prototypes and solutions. Whether you're exploring or building something serious, Makers Lab is where creativity meets practical execution.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;